import "./lib/admin/recoveryBootstrap";
import { createRoot } from "react-dom/client";
import "./lib/purgeDevState";
import { startWhatsAppCtaWatchdog } from "./lib/whatsappCtaWatchdog";
import { startWhatsAppCtaSentryForwarder } from "./lib/whatsappCtaSentry";
import { startWhatsAppCtaViolationStore } from "./lib/whatsappCtaViolationStore";
import App from "./App.tsx";
import "./index.css";

// After a new deploy, an open tab may request old page files that no longer
// exist. Reload once to fetch the current version instead of showing a blank page.
const RELOAD_KEY = "sg-chunk-reload-at";
const reloadForStaleChunk = () => {
  const last = Number(sessionStorage.getItem(RELOAD_KEY) || 0);
  if (Date.now() - last < 10_000) return; // avoid reload loops
  sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  window.location.reload();
};
window.addEventListener("vite:preloadError", (event) => {
  event.preventDefault();
  reloadForStaleChunk();
});
window.addEventListener("unhandledrejection", (event) => {
  const msg = String(event.reason?.message || event.reason || "");
  if (/Importing a module script failed|Failed to fetch dynamically imported module|error loading dynamically imported module/i.test(msg)) {
    reloadForStaleChunk();
  }
});

const root = document.getElementById("root");
if (root) createRoot(root).render(<App />);

startWhatsAppCtaViolationStore();
startWhatsAppCtaWatchdog();
startWhatsAppCtaSentryForwarder();
